
import VueIpInput from 'vue-ip-input'
import moment from 'moment'

export default {
    name: 'UserDialogLoginTabComponent',
    components: {
        'vue-ip-input': VueIpInput
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // model de los menu para seleccionar fechas
        menuSinceDate: false,
        menuToDate: false,
        // fechas formateadas
        selectedSinceDate: '',
        selectedToDate: '',
        // máscara para la IP
        // '###.###.###.###'
        ipMask: [/[0-2]/, /[0-9]/, /[0-9]/, '.', /[0-2]/, /[0-9]/, /[0-9]/, '.', /[0-2]/, /[0-9]/, /[0-9]/, '.', /[0-2]/, /[0-9]/, /[0-9]/]
    }),
    computed: {
        disableIpRange () {
            if (!this.model.authorizedIpRange) {
                return `disabledIpRange`
            }
        }
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * Cuando cambia la ip del campo inicio del rango
         * @param {*} ip
         */
        onIpFromChange (ip) {
            this.model.ipRangeFrom = ip
        },
        /**
         * Cuando cambia la ip del campo fin del rango
         * @param {*} ip
         */
        onIpToChange (ip) {
            this.ipRangeTo = ip
        },
        /**
         * Lo ejecuta el menú para seleccionar la fecha de inicio del rango
         */
        closeSinceDateMenu () {
            this.menuSinceDate = false
            this.selectedSinceDate = this.model.sinceDate ? moment(this.model.sinceDate).format('DD/MM/YYYY') : ''
        },
        /**
         * Lo ejecuta el menú para seleccionar la fecha de fin del rango
         */
        closeToDateMenu () {
            this.menuToDate = false
            this.selectedToDate = this.model.toDate ? moment(this.model.toDate).format('DD/MM/YYYY') : ''
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm (newVal, oldVal) {
            if (newVal!==oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Actualizo el valor de las fechas
         */
        model: {
            deep: true,
            immediate: true,
            handler() {
                this.selectedSinceDate = this.model.sinceDate ? moment(this.model.sinceDate).format('DD/MM/YYYY') : ''
                this.selectedToDate = this.model.toDate ? moment(this.model.toDate).format('DD/MM/YYYY') : ''
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.userDialogLoginTabForm) {
                this.$refs.userDialogLoginTabForm.resetValidation()
            }
        }
    }
}
